var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("menu-toggle " + (_vm.drawer ? 'menu-toggle--active' : '')),on:{"click":_vm.onMenuToggle}},[_c('div',{staticClass:"menu-toggle--1"}),_c('div',{staticClass:"menu-toggle--2"}),_c('div',{staticClass:"menu-toggle--3"})])}
var staticRenderFns = []

export { render, staticRenderFns }